import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { collection, limit, onSnapshot, query, where } from "firebase/firestore";
import { auth, db } from "../lib/firebase";

function safeStr(v) {
  return String(v ?? "").trim();
}

export default function IncomingCallListener() {
  const nav = useNavigate();
  const loc = useLocation();
  const [uid, setUid] = useState("");
  const lastOpenedRef = useRef("");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUid(u?.uid || "");
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!uid) return;

    const qy = query(
      collection(db, "calls"),
      where("toUid", "==", uid),
      where("status", "==", "ringing"),
      limit(1)
    );

    const unsub = onSnapshot(qy, (snap) => {
      if (snap.empty) return;

      const d = snap.docs[0];
      const callId = d.id;
      const call = d.data() || {};
      const matchId = safeStr(call.matchId);
      const mode = safeStr(call.mode) || "voice";

      if (!matchId) return;

      // ✅ Don't open if we're already on that call screen
      const key = `${matchId}__${callId}`;
      if (lastOpenedRef.current === key) return;

      // ✅ Avoid re-opening repeatedly
      lastOpenedRef.current = key;

      // ✅ If already on /call, do nothing
      if (safeStr(loc.pathname).startsWith("/call/")) return;

      // ✅ Navigate receiver to call screen (incoming)
      nav(`/call/${matchId}?callId=${callId}&mode=${mode}`, { replace: false });
    });

    return () => unsub();
  }, [uid, nav, loc.pathname]);

  return null;
}